var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRatingLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18457_165217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.08 109.245L34.18 108.635C34.23 108.312 34.2035 107.982 34.1028 107.671C34.0021 107.361 33.8298 107.078 33.6 106.845L15.6 88.8454C14.0743 87.313 13.1513 85.2825 13 83.1254L11.71 67.8354C11.71 67.6454 11.71 65.9054 11.71 65.7254L15.33 48.8854C15.3566 48.7502 15.4109 48.6219 15.4895 48.5086C15.5681 48.3953 15.6693 48.2995 15.7866 48.2272C15.904 48.1549 16.0351 48.1076 16.1716 48.0884C16.3081 48.0692 16.4472 48.0784 16.58 48.1154C19.42 48.8854 23.45 53.0554 20.48 65.4154L25 74.3054",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5199 89.2054L24.9999 80.9454C20.9999 77.5654 23.9399 70.1654 31.7499 76.8954L41.4199 84.1654C60.6499 85.8754 56.8399 109.325 56.8399 109.325",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2002 121.485V109.545H61.6002V122.005",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5498 117.205H61.5998",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6202 115.125C58.3824 115.125 59.0002 114.427 59.0002 113.565C59.0002 112.704 58.3824 112.005 57.6202 112.005C56.8581 112.005 56.2402 112.704 56.2402 113.565C56.2402 114.427 56.8581 115.125 57.6202 115.125Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9195 109.245L93.8195 108.635C93.7695 108.312 93.796 107.982 93.8967 107.671C93.9974 107.361 94.1696 107.078 94.3995 106.845L112.4 88.8454C113.914 87.3258 114.836 85.3149 115 83.1754L116.29 67.8854C116.29 67.6954 116.29 65.9554 116.29 65.7754L112.67 48.9354C112.643 48.8001 112.589 48.6718 112.51 48.5586C112.431 48.4453 112.33 48.3495 112.213 48.2772C112.095 48.2049 111.964 48.1576 111.828 48.1384C111.691 48.1191 111.552 48.1283 111.42 48.1654C108.58 48.9354 104.55 53.1054 107.52 65.4654L103 74.3054",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4804 89.2054L103 80.9454C107 77.5654 104.06 70.1654 96.2504 76.8954L86.5804 84.1654C67.3504 85.8754 71.1604 109.325 71.1604 109.325",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8004 121.485V109.545H66.4004V122.005",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4504 117.205H66.4004",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.38 115.125C71.1422 115.125 71.76 114.427 71.76 113.565C71.76 112.704 71.1422 112.005 70.38 112.005C69.6178 112.005 69 112.704 69 113.565C69 114.427 69.6178 115.125 70.38 115.125Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.25 55.9554C62.25 55.9554 50.68 55.2254 49.79 45.4054C49.79 45.4054 59.68 46.1554 62.25 55.9554Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3701 55.9554C65.3701 55.9554 76.9401 55.2254 77.8201 45.4054C77.8201 45.4054 67.9401 46.1554 65.3701 55.9554Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5905 74.7054C62.5905 74.7054 46.9305 73.7054 45.7305 60.4554C45.7305 60.4554 59.1105 61.4054 62.5905 74.7054Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4102 74.6354C65.4102 74.6354 81.0701 73.6354 82.2701 60.3854C82.2701 60.4054 68.8902 61.4054 65.4102 74.6354Z",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7695 90.3354V41.1154H65.0295V90.3354",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8595 41.3554C69.8463 41.3554 74.6995 36.4753 74.6995 30.4554C74.6995 24.4355 69.8463 19.5554 63.8595 19.5554C57.8728 19.5554 53.0195 24.4355 53.0195 30.4554C53.0195 36.4753 57.8728 41.3554 63.8595 41.3554Z",
    stroke: "#EE5A00",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2504 27.2054C66.5963 26.5497 65.7624 26.1027 64.8543 25.9212C63.9461 25.7396 63.0045 25.8316 62.1487 26.1855C61.2928 26.5393 60.5612 27.1392 60.0464 27.9091C59.5316 28.6789 59.2568 29.5843 59.2568 30.5104C59.2568 31.4365 59.5316 32.3418 60.0464 33.1117C60.5612 33.8816 61.2928 34.4814 62.1487 34.8353C63.0045 35.1892 63.9461 35.2811 64.8543 35.0996C65.7624 34.918 66.5963 34.4711 67.2504 33.8154",
    stroke: "#EE5A00",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9199 29.4254H63.5199",
    stroke: "#EE5A00",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9199 31.5954H63.5199",
    stroke: "#EE5A00",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5703 6.80542V12.3454",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2604 13.4754L83.9404 20.1254",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.65 30.6954L96.1602 34.7454",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0195 13.4754L43.9695 19.9054",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9902 31.9854L32.3002 34.7454",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8398 68.3054L62.1098 74.1654",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9196 68.3054L65.6396 74.1654",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7598 51.3554L61.6698 55.6754",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.44 51.3554L65.54 55.6754",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18457_165217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.405396)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingLoading);
export default __webpack_public_path__ + "static/media/ratingLoading.475a2acbced38aae5870926487f9a8ae.svg";
export { ForwardRef as ReactComponent };